const API_URL = 'https://api.coingecko.com/api/v3';

export const getCurrentPrice = async (coin) => {
  try {
    const response = await fetch(`${API_URL}/simple/price?ids=${coin}&vs_currencies=usd`);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching current price', error);
    throw error;
  }
};

export const getHistoricalPrice = async (coin, date) => {
  try {
    const response = await fetch(`${API_URL}/coins/${coin}/history?date=${date}&localization=false`);
    const data = await response.json();
    return data.market_data.current_price.usd;
  } catch (error) {
    console.error('Error fetching historical price:', error);
    throw error;
  }
};
